import { createSelector } from 'reselect';

import { initialState } from './reducer';

const selectState = (state: any) => state.get('causeFormPage') || initialState;

export const selectLoading = createSelector(selectState, (state) => state.get('loading'));
